window.addEventListener('load', () => {
    document.querySelectorAll(".popup-window .form-input").forEach((item) => {
        item.addEventListener("focus", function () {
            this.parentNode.classList.add("moved");
        });
    });

    document.querySelectorAll(".popup-window .form-input").forEach((item) => {
        item.addEventListener("blur", function () {
            if (this.value < 1) {
                this.parentNode.classList.remove("moved");
            }
        });
    });

    $('.popup-window .form-input').on('blur change paste keyup', function () {
        var $this = $(this);
        $this.parent().removeClass('invalid');

        var sibling = $this.siblings('.error-text');
        if (sibling.length == 1) {
            sibling.remove();
        }
    });

    siteTextAreaDynamic();
})


function ALXErrorSendClass() {
    function strip_tags(str) {
        return str.replace(/<\/?[^>]+>/gi, '');
    }

    var errSendMsg = ALXerrorSendMessages;

    var ErrorText = {'start': '', 'body': '', 'end': ''};
    var BeforeChars = 50;
    var AfterChars = 50;
    var _select;

    function getSelectedText() {
        ErrorText.start = '';
        ErrorText.body = '';
        ErrorText.end = '';

        var str_select, text_end, _end, _start, text_start;
        if (window.getSelection) {
            str_select = window.getSelection();
        } else if (document.getSelection) {
            str_select = document.getSelection();
        } else if (document.selection) {
            str_select = document.selection;
        }
        if (!str_select) {
            return false;
        }
        if (str_select.getRangeAt && str_select.rangeCount > 0) {
            if (document.getSelection()) {
                _select = document.getSelection();
            } else if (window.getSelection()) {
                _select = window.getSelection();
            }
            _select = _select.toString();
            _start = document.createRange();
            _start.setStartBefore(str_select.getRangeAt(0).startContainer);
            _start.setEnd(str_select.getRangeAt(0).startContainer, str_select.getRangeAt(0).startOffset);
            text_start = _start.toString();

            //end text
            _end = str_select.getRangeAt(0).cloneRange();
            _end.setStart(str_select.getRangeAt(0).endContainer, str_select.getRangeAt(0).endOffset);
            _end.setEndAfter(str_select.getRangeAt(0).endContainer);
            text_end = _end.toString();
            text_start = text_start.substr(text_start.length - BeforeChars, text_start.length);
            text_end = text_end.substr(0, AfterChars);
            //start text
        } else {
            return false;
        }

        if (str_select.createRange) {
            _select = str_select.createRange().text;
            //start text
            _start = str_select.createRange();
            _start.moveStart("character", -BeforeChars);
            _start.moveEnd("character", -_select.length);
            text_start = _start.text;

            //end test
            _end = str_select.createRange();
            _end.moveStart("character", _select.length);
            _end.moveEnd("character", AfterChars);
            text_end = _end.text;
            document.selection.empty();
        }

        if (!_select.length) {
            return false;
        }
        if (_select.length > 250) {

            var content_LongText = '\
                                <div id="ga_SendError_LongText">\
                                                <div style="color: red; font-size: 20px"><b>' + errSendMsg.LongText + '</b></div><br /><br />' + errSendMsg.LongText2 + '\
                                </div>';

            BX.AlxErrDialog_DLongTxt = new BX.PopupWindow("ga_ErrorWindow_long", window.body, {
                className: 'ga_ErrorWindow',
                content: content_LongText,
                closeIcon: {right: "20px", top: "10px"},
                titleBar: "",
                zIndex: 0,
                offsetLeft: 0,
                offsetTop: 0,
                draggable: {restrict: false},
                overlay: {backgroundColor: 'black', opacity: '80'},
                height: '130',
                width: '350',
                buttons: [
                    new BX.PopupWindowButton({
                        text: errSendMsg.close,
                        className: "webform-button-link-cancel button",
                        events: {
                            click: function () {
                                this.popupWindow.close();
                            }
                        }
                    })
                ]
            });

            BX.AlxErrDialog_DLongTxt.show();
            return false;
        }
        ErrorText.start = text_start;
        ErrorText.body = _select;
        ErrorText.end = text_end;
    }

    function trimLeft(str) {
        var firstSimb;
        str.substring(0, 1) == " " ? firstSimb = " " : firstSimb = "";
        return firstSimb + str.replace(/^\s+/, '');
    }

    function trimRight(str) {
        var lastSimb;
        str.substring(str.length - 1, str.length) == " " ? lastSimb = " " : lastSimb = "";
        return str.replace(/\s+$/, '') + lastSimb;
    }

    function trimBoth(str) {
        return trimRight(trimLeft(str));
    }

    function trimSpaces(str) {
        return str.replace(/\s{2,}/g, ' ');
    }

    function esErrorSend() {

        var new_href = window.location.href;
        var hashpos = new_href.indexOf('#'), hash = '';
        if (hashpos != -1) {
            hash = new_href.substr(hashpos);
            new_href = new_href.substr(0, hashpos);
        }
        var url = new_href;

        var oData = {
            "AJAX_CALL": "Y",
            "ERROR_SEND": "Y",
            "ERROR_TEXT_START": trimBoth(ErrorText.start),
            "ERROR_TEXT_BODY": document.getElementById('error_body').innerHTML,
            "ERROR_TEXT_END": trimBoth(ErrorText.end),
            "COMMENT": document.getElementById("error-comment").value,
            "ERROR_URL": window.location.href
        };
        if (ALXerrorSendMessages.use_captcha) {
            var form = document.getElementById("send-error");
            if (!!form) {
                var token = form.querySelector('input[name="smart-token"]');
                if (!!token) {
                    oData['smart-token'] = token.value;
                }
            }
        }
        BX.ajax.post(url, oData, function (res) {

            BX.AlxErrDialog.close();

            if (trim(res) != "OK!")
                BX.AlxErrDialog_no.show();
            else
                BX.AlxErrDialog_ok.show();
        });
    }

    function trim(string) {
        return string.replace(/(^\s+)|(\s+$)/g, "");
    }

    var content_no = '<div id="ga_SendErrorOk"><div style="color: red; font-size: 20px"><b>' + errSendMsg.senderror + '</b></div><span style="font-size:12px;color:#7d7d7d"><br />' + errSendMsg.LongText2 + '</span></div>';
    var content_ok = '\
        <div id="ga_SendErrorOk">\
                <div width="100%" class="no-bootom-border" style="padding-top:8px !important;"><span class="page-title contactus-section__body-title">\
                ' + errSendMsg.text_ok + '</span></div>\
        </div>';

    BX.AlxErrDialog_ok = new BX.PopupWindow("ga_ErrorWindow_ok", window.body, {
        className: 'ga_ErrorWindow',
        content: content_ok,
        closeIcon: {right: "10px", top: "10px"},
        titleBar: "",
        zIndex: 0,
        offsetLeft: 0,
        offsetTop: 0,
        draggable: {restrict: false},
        overlay: {backgroundColor: 'black', opacity: '80'},
        height: '130',
        width: '350',
        buttons: [
            new BX.PopupWindowButton({
                text: errSendMsg.close,
                className: "webform-button-link-cancel button",
                events: {
                    click: function () {
                        this.popupWindow.close();
                    }
                }
            })
        ]
    });

    BX.AlxErrDialog_no = new BX.PopupWindow("ga_ErrorWindow_no", window.body, {
        className: 'ga_ErrorWindow',
        content: content_no,
        closeIcon: {right: "10px", top: "10px"},
        titleBar: "",
        zIndex: 0,
        offsetLeft: 0,
        offsetTop: 0,
        draggable: {restrict: false},
        overlay: {backgroundColor: 'black', opacity: '80'},
        height: '130',
        width: '350',
        buttons: [
            new BX.PopupWindowButton({
                text: errSendMsg.close,
                className: "webform-button-link-cancel button",
                events: {
                    click: function () {
                        this.popupWindow.close();
                    }
                }
            })
        ]
    });

    var contentErr = '\
<div id="send-error"' + (ALXerrorSendMessages.use_captcha?' data-form-id="send-error"':'') + '>\
        <div class="contactus-section__error-content">\
            <span class="page-title contactus-section__body-title">' + errSendMsg.head + ':</span>\
            <div style="font-family: Stem-Regular;padding:10px;border:1px solid #d1d1d1;background-color:#fafafa;width:470px;max-width: 100%;margin:7px 0px 13px 0px;color:#7d7d7d;font-size:12px;box-sizing:content-box;">\
                <span id="error_start"></span><font color="red" id="error_body"></font><span id="error_end"></span>\
            </div>\
        </div>\
        <div class="form-item contactus-section__body-form-item contactus-section__body-form_textarea-box" style="width:470px;max-width: 100%;padding:0;border-bottom:1px solid #4b4b4b;margin:20px 0px 3px 0px;box-sizing:content-box;">\
            <textarea class="input-js contactus-section__body-form-item_textarea--large form-input form-input--textarea auto contactus-section__body-form-item_textarea--large-js" name="comment" id="error-comment" rows=1 cols=1 style="resize:none;width:100%;border:0px;min-height:30px;padding:0px;"></textarea>\
            <label class="form-label contactus-section__body-form-item-label contactus-section__body-form-item_textarea_label" >' + errSendMsg.comment_1 + '<span class="comment_part_2">' + errSendMsg.comment_2 + '</span>' + ':</label> \
        </div>\
        ' + (ALXerrorSendMessages.use_captcha ?
        '<div class="form-item contactus-section__body-form_captcha" data-field-holder style="width: 90%;">' +
            '<div id="captcha-container-send-error"></div>' +
        '</div>' : '') + '\
</div>';

    BX.AlxErrDialog = new BX.PopupWindow("ga_ErrorWindow", window.body, {
        className: 'ga_ErrorWindow',
        content: contentErr,
        closeIcon: {right: "20px", top: "10px"},
        titleBar: {
            content: BX.create("div", {
                html: errSendMsg.footer,
                'props': {'className': 'ga_ErrorTitleBar page-title contactus-section__body-title'}
            })
        },
        //'<div class="ga_ErrorTitleBar"><span style="font-size:16px;color:#143f6d">'+errSendMsg.footer+'</span></div>',

        zIndex: 0,
        offsetLeft: 0,
        offsetTop: 0,
        draggable: {restrict: false},
        overlay: {backgroundColor: 'black', opacity: '80'},
        buttons: [
            new BX.PopupWindowButton({
                text: errSendMsg.ButtonSend,
                className: "button",
                events: {
                    click: function () {
                        if (ALXerrorSendMessages.use_captcha) {
                            Site.Common.Yandex.handleSubmitButton('send-error');
                        } else {
                            esErrorSend();
                        }
                    }
                }
            }),
            new BX.PopupWindowButtonLink({
                text: errSendMsg.cancel,
                className: "webform-button-link-cancel",
                events: {
                    click: function () {
                        this.popupWindow.close();
                    }
                }
            })
        ]
    });

    BX.bind(document, 'keydown', ga_error);
    BX.bind(BX("find-error-button"), 'click', ga_error);
    document.querySelectorAll(".find-error-button").forEach((item) => {
        BX.bind(item, 'click', ga_error);
    });

    function ga_error(event) {
        var kCode = window.event ? window.event.keyCode : (event.keyCode ? event.keyCode : (event.which ? event.which : null));
        var fCode = window.event ? window.event.ctrlKey : event.ctrlKey;

        if (event.type === "click" || (kCode == 13 && fCode)) {
            if (BX.AlxErrDialog.isOpen) {
                esErrorSend();
            } else {
                if (getSelectedText() !== false || event.type === "click") {
                    ga_tune_form();
                    BX.AlxErrDialog.show();
                }
            }
            return false;
        }
    }

    function ga_tune_form() {
        if (ALXerrorSendMessages.use_captcha) {
            Site.Common.Yandex.addFormCallBack('send-error', esErrorSend);
        }

        var ctrl;
        document.getElementById('error-comment').value = '';

        if (ErrorText.body.length > 0) {
            document.getElementById('error_start').innerHTML = ErrorText.start;
            document.getElementById('error_body').innerHTML = ErrorText.body;
            document.getElementById('error_end').innerHTML = ErrorText.end;

            ctrl = document.querySelector(".contactus-section__error-content");
            if (!!ctrl) {
                ctrl.style.display = 'block';
            }
            ctrl = document.querySelector(".contactus-section__body-form_textarea-box .comment_part_2");
            if (!!ctrl) {
                ctrl.style.display = 'inline';
            }
        } else {
            document.getElementById('error_start').innerHTML = '';
            document.getElementById('error_body').innerHTML = '';
            document.getElementById('error_end').innerHTML = '';

            ctrl = document.querySelector(".contactus-section__error-content");
            if (!!ctrl) {
                ctrl.style.display = 'none';
            }
            ctrl = document.querySelector(".contactus-section__body-form_textarea-box .comment_part_2");
            if (!!ctrl) {
                ctrl.style.display = 'none';
            }
        }
    }
}

BX.ready(function () {
    if (typeof ALXErrorSendClass == 'function') {
        new ALXErrorSendClass();
    }
});